export default __webpack_public_path__ + "static/media/pragmatic.92884054.jpg";